/* eslint-disable */
import { IHttpClient } from '../api';
import { Client } from "@/domain/client";
import { AppConfig} from "@/utils/enums";

const apiUrl = `${process.env.VUE_APP_API_BASEURL}`;

export interface ClientResponse {
    clients: Client[];
}

export const ClientApi = (http: IHttpClient) => ({
    getClients: () =>
        http.get<ClientResponse>(apiUrl + AppConfig.API_CLIENTS_URL).then(response => ({
            clients: response.data
        })),
    saveNewClient: (newClient: Client) =>
        http.post<Client>(apiUrl + AppConfig.API_CLIENTS_URL, newClient)
            .catch(error => {
                return error;
            }),
    updateClient: (updatedClient: Client) =>
        http.put<Client>(apiUrl + AppConfig.API_CLIENTS_URL, updatedClient)
            .catch(error => {
                return error;
            }),
    deleteClient: (clientId: number) =>
        http.delete<number>(apiUrl + AppConfig.API_CLIENTS_URL + '/' + clientId)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error;
            })
});
